import React, { FC } from "react";
import { useGenericData } from "@app/hooks/use-generic-data/useGenericData";
import { HeroProps } from "./types";
import { HeroVariants } from "./components/hero-variants/HeroVariants";

export const Hero: FC<HeroProps> = (props) => {
  const { notificationBar } = useGenericData();

  return (
    <HeroVariants
      {...{ ...props, isNotificationBarEnabled: notificationBar?.isEnabled }}
    />
  );
};
